export default __webpack_public_path__ + "static/media/evenshotBG.4b0c35bf.png";